export default __webpack_public_path__ + "static/media/table.32ffee66.svg";